import React, { useEffect, useState, useCallback, useContext } from 'react';
import styles from  './SymbolDescription.module.css';
import { isTokenExpired, handleLogin } from '../pages/utils/AuthenticationHelper';
import { useSelector } from 'react-redux';
import { CsrfTokenContext } from '../CsrfTokenContext';

const SymbolDescription = (symbol) => {  

  const [description, setDescription] = useState('');
  const [delayShow, setDelayShow] = useState(false);
  const [descriptionEdit, setDescriptionEdit] = useState('');
  const [edit, setEdit] = useState(false);
  const { isAdmin } = useSelector(state => state.globalData);

  const csrfToken = useContext(CsrfTokenContext); 
     
  const refreshTokenIfNeeded = useCallback(async () => {
    if (isTokenExpired()) {        
      await handleLogin();
    }    
  },[]);

  const getSymbolDescription = useCallback(async () => {
    try {
      setDescription('');
        const strFetch = `/api/symbolDescription?symbol=${symbol.symbol}`;
                  
        const response = await fetch(strFetch, {
          method: 'GET',            
          headers: {
              'Content-Type': 'application/json',                
          }
      });
        
        if (!response.ok) {              
            const errorData = await response.json();
            console.log(errorData.error);
        }
        const result = await response.json();
        setDescription(result[0]['desc']);
        setDescriptionEdit(result[0]['desc']);

        setTimeout(()=>{
          setDelayShow(true);
        }, 3000);

    } catch (err) {            
        console.error('Error plotting data:', err);
    }          
  },[symbol.symbol]);
  
  useEffect(() => {

    setEdit(false);
    setDelayShow(false);

    refreshTokenIfNeeded();  

    getSymbolDescription();   

  }, [symbol.symbol, refreshTokenIfNeeded, getSymbolDescription]);

  const saveDescription = async () => {
    try {

      await refreshTokenIfNeeded();

      var description = edit ? descriptionEdit : document.getElementById('memo1').value;

      if(description==='') return;
                    
      const response = await fetch(`/api/save_description`, {
          method: 'POST',
          // credentials: 'include',
          headers: {              
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken, // Ensure the CSRF token is correctly passed
          },
          body: JSON.stringify({symbol : symbol.symbol, description : description})
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error);
      }

      getSymbolDescription();
      setEdit(false);
      setDescriptionEdit('');

    } catch (err) {            
        console.error('Error plotting data:', err);
    }        
  }

  const editDescription = ()=>{
    setEdit(true);    
  }

  const cancel = ()=>{
    setEdit(false);    
  }

  return (
    <>
      {!edit ? (
        description !== '' ? (
          <>
            <div style={{display:'flex', alignItems:'center', justifyContent:'center' }}>
              <h2 style={{ padding: '20px' }}>Crypto Description</h2>
              {isAdmin && (
                <div
                  className={styles.edit_button}
                  onClick={editDescription}                  
                >
                  Edit
                </div>
              )}
            </div>
            <div className={styles.desc_container}>
              <span className={styles.description}>{description}</span>
            </div>
          </>
        ) : (
          isAdmin && delayShow && (
            <div className={styles.container}>
              <textarea
                className={styles.input_txt}
                id="memo1"
                placeholder={`Enter Description for ${symbol.symbol}`}
                rows="5"
                cols="30"                
              ></textarea>
              <div className={styles.save_button} onClick={saveDescription}>
                Save
              </div>
            </div>
          )
        )
      ) : isAdmin ? (
        <div className={styles.container}>
          <textarea
            className={styles.input_txt}
            id="memo2"
            placeholder={`Enter Description for ${symbol.symbol}`}
            value={descriptionEdit}
            rows="5"
            cols="30"
            onChange={(e) => setDescriptionEdit(e.target.value)}
          ></textarea>
          <div style={{display:'flex', alignItems:'center'}} onClick={saveDescription}>
            <div className={styles.save_button} onClick={saveDescription}>
              Save
            </div>
            <div className={styles.cancel_button} onClick={cancel}>
              Cancel
            </div>
          </div>
        </div>
      ) : null}
    </>
  );

};

export default SymbolDescription;